import { h } from 'preact';
import { registerPatternDecoder } from './index';
import { IToastOptions } from '@/components/create-toast';
import { defaultCoinImage, defaultGemImage } from '@/assets/coin';

registerPatternDecoder(/^\{slot-coin\}/, (match, options: IToastOptions) => {
  const coinImage = options?.coinImage ?? defaultCoinImage;
  return <img src={coinImage} alt="🪙" style={{ height: '1em', verticalAlign: 'middle' }} />;
});

registerPatternDecoder(/^\{slot-gem\}/, (match, options: IToastOptions) => {
  const gemImage = options?.gemImage ?? defaultGemImage;
  const gemStyle = options?.customStyle?.gem ?? { width: '28px', height: '28px' };
  return <img src={gemImage} alt="🪙" style={{ ...gemStyle, verticalAlign: 'middle' }} />;
});
